var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notifications',{attrs:{"group":"app","position":_vm.position,"duration":5000,"max":_vm.max}})
}
var staticRenderFns = []

export { render, staticRenderFns }